import { render, staticRenderFns } from "./DangerousGoodImportDialog.vue?vue&type=template&id=349edfc9"
import script from "./DangerousGoodImportDialog.vue?vue&type=script&lang=js"
export * from "./DangerousGoodImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports